import srOnly from '@fukku/styles/src/srOnly.module.css'
import cx from 'classix'
import { applyStylesIf } from 'utils/applyStylesIf/applyStylesIf'
import { CloseModal } from '../../CloseModal/CloseModal'
import styles from '../ModalHeader.module.css'

export function CloseOnlyHeader({
	close,
	title,
	floatClose,
	preventClose,
	className,
}: {
	readonly title: string
	readonly preventClose: boolean
	readonly floatClose: boolean
	readonly close: () => void
	readonly className: string
}) {
	return (
		<header
			className={cx(
				className,
				styles.header,
				applyStylesIf(!floatClose, styles.closeOnly),
				applyStylesIf(floatClose, styles.noHeight)
			)}
		>
			<div className={styles.positionAnchor}>
				<span className={srOnly.className}>{title}</span>
				<CloseModal
					preventClose={preventClose}
					close={close}
					float={floatClose}
				/>
			</div>
		</header>
	)
}
